import React from 'react';
import FolderBarFolderDropdownContainer, {
  OwnProps,
} from './FolderBarFolderDropdown.container';
import FolderBarFolderDropdown from './FolderBarFolderDropdown';

export default FolderBarFolderDropdownContainer(
  FolderBarFolderDropdown
) as React.ComponentType<OwnProps>;
